/* eslint-disable */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';


@injectable()
export class CalculatorApi {
    constructor(private readonly httpClient: HttpClient) {
    }


    sendTroubleshootingCalculation = async (
        data: TroubleshootingToolsRequestModel,
        cancellationToken?: CancelToken,
    ) => {
        return this.httpClient.post<
            CalculationResponseModel,
            TroubleshootingToolsRequestModel
        >('/troubleshooting_chat', data, {
            cancelToken: cancellationToken,
        });
    };
}

export interface TroubleshootingToolsRequestModel extends BaseRequestModel {
    id: string;
    type: "tool";
    job_id: number;
    question: string;
}


export interface CalculationResponseModel {
    answer: {
        answer_text: string
    }
    summary: string;
}
